import { render, staticRenderFns } from "./reminderList.vue?vue&type=template&id=71019d49&"
import script from "./reminderList.vue?vue&type=script&lang=js&"
export * from "./reminderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports